import { TruncatedText } from "@/components/TruncatedText";
import { CellContext } from "@tanstack/react-table";
import { numericFormatter } from "react-number-format";

const DECIMAL_SCALE = 2;
export const tableText =
    <T, _>(tableId: string) =>
    ({ row }: CellContext<T, unknown>) => {
        if (tableId === "totalInvoiceAmount") {
            const valueCurrency = row.getValue(tableId) as string;
            const value = valueCurrency?.split(" ")[0];
            const currency = valueCurrency?.split(" ")[1];
            const valueFormatted = numericFormatter(value, {
                thousandSeparator: ",",
                decimalSeparator: ".",
                decimalScale: DECIMAL_SCALE
            });
            return <TruncatedText text={`${valueFormatted} ${currency}`} />;
        }

        return <TruncatedText text={row.getValue(tableId)} />;
    };
